export default {
  'primarySolid50': 'rgba(234, 230, 254, 1.00)',
  'primarySolid100': 'rgba(189, 176, 251, 1.00)',
  'primarySolid200': 'rgba(157, 138, 249, 1.00)',
  'primarySolid300': 'rgba(112, 84, 246, 1.00)',
  'primarySolid400': 'rgba(84, 51, 245, 1.00)',
  'primarySolid500': 'rgba(41, 0, 242, 1.00)',
  'primarySolid600': 'rgba(37, 0, 220, 1.00)',
  'primarySolid700': 'rgba(29, 0, 172, 1.00)',
  'primarySolid800': 'rgba(23, 0, 133, 1.00)',
  'primarySolid900': 'rgba(13, 0, 81, 1.00)',
  'primaryTransparent50': 'rgba(41, 0, 242, 0.05)',
  'primaryTransparent100': 'rgba(41, 0, 242, 0.10)',
  'primaryTransparent200': 'rgba(41, 0, 242, 0.20)',
  'primaryTransparent300': 'rgba(41, 0, 242, 0.30)',
  'primaryTransparent400': 'rgba(41, 0, 242, 0.40)',
  'primaryTransparent500': 'rgba(41, 0, 242, 0.50)',
  'primaryTransparent600': 'rgba(41, 0, 242, 0.60)',
  'primaryTransparent700': 'rgba(41, 0, 242, 0.70)',
  'primaryTransparent800': 'rgba(41, 0, 242, 0.80)',
  'primaryTransparent900': 'rgba(41, 0, 242, 0.90)',
  'neutralSolid0': 'rgba(255, 255, 255, 1.00)',
  'neutralSolid200': 'rgba(244, 244, 244, 1.00)',
  'neutralSolid300': 'rgba(235, 235, 236, 1.00)',
  'neutralSolid400': 'rgba(191, 191, 191, 1.00)',
  'neutralSolid500': 'rgba(138, 136, 144, 1.00)',
  'neutralSolid600': 'rgba(107, 103, 116, 1.00)',
  'neutralSolid700': 'rgba(54, 50, 64, 1.00)',
  'neutralSolid800': 'rgba(37, 34, 43, 1.00)',
  'neutralSolid900': 'rgba(24, 21, 30, 1.00)',
  'neutralSolid1000': 'rgba(0, 0, 0, 1.00)',
  'neutralBlackTransparent50': 'rgba(0, 0, 0, 0.05)',
  'neutralBlackTransparent100': 'rgba(0, 0, 0, 0.10)',
  'neutralBlackTransparent200': 'rgba(0, 0, 0, 0.20)',
  'neutralBlackTransparent300': 'rgba(0, 0, 0, 0.30)',
  'neutralBlackTransparent400': 'rgba(0, 0, 0, 0.40)',
  'neutralBlackTransparent500': 'rgba(0, 0, 0, 0.50)',
  'neutralBlackTransparent600': 'rgba(0, 0, 0, 0.60)',
  'neutralBlackTransparent700': 'rgba(0, 0, 0, 0.70)',
  'neutralBlackTransparent800': 'rgba(0, 0, 0, 0.80)',
  'neutralBlackTransparent900': 'rgba(0, 0, 0, 0.90)',
  'neutralWhiteTransparent20': 'rgba(255, 255, 255, 0.02)',
  'neutralWhiteTransparent70': 'rgba(255, 255, 255, 0.07)',
  'neutralWhiteTransparent150': 'rgba(255, 255, 255, 0.15)',
  'neutralWhiteTransparent200': 'rgba(255, 255, 255, 0.20)',
  'neutralWhiteTransparent250': 'rgba(255, 255, 255, 0.40)',
  'neutralWhiteTransparent500': 'rgba(255, 255, 255, 0.50)',
  'neutralWhiteTransparent600': 'rgba(255, 255, 255, 0.60)',
  'neutralWhiteTransparent700': 'rgba(255, 255, 255, 0.70)',
  'neutralWhiteTransparent800': 'rgba(255, 255, 255, 0.80)',
  'neutralWhiteTransparent900': 'rgba(255, 255, 255, 0.90)',
  'neutralWhiteTransparent0': 'rgba(255, 255, 255, 0.00)',
  'secondarySolid50': 'rgba(232, 233, 248, 1.00)',
  'secondarySolid100': 'rgba(183, 186, 234, 1.00)',
  'secondarySolid200': 'rgba(149, 153, 223, 1.00)',
  'secondarySolid300': 'rgba(100, 106, 209, 1.00)',
  'secondarySolid400': 'rgba(70, 77, 200, 1.00)',
  'secondarySolid500': 'rgba(24, 33, 186, 1.00)',
  'secondarySolid600': 'rgba(22, 30, 169, 1.00)',
  'secondarySolid700': 'rgba(17, 23, 132, 1.00)',
  'secondarySolid800': 'rgba(13, 18, 102, 1.00)',
  'secondarySolid900': 'rgba(10, 14, 78, 1.00)',
  'secondaryTransparent50': 'rgba(57, 20, 145, 0.05)',
  'secondaryTransparent100': 'rgba(57, 20, 145, 0.10)',
  'secondaryTransparent200': 'rgba(57, 20, 145, 0.20)',
  'secondaryTransparent300': 'rgba(57, 20, 145, 0.30)',
  'secondaryTransparent400': 'rgba(57, 20, 145, 0.40)',
  'secondaryTransparent500': 'rgba(57, 20, 145, 0.50)',
  'secondaryTransparent600': 'rgba(57, 20, 145, 0.60)',
  'secondaryTransparent700': 'rgba(57, 20, 145, 0.70)',
  'secondaryTransparent800': 'rgba(57, 20, 145, 0.80)',
  'secondaryTransparent900': 'rgba(57, 20, 145, 0.90)',
  'greenSolid50': 'rgba(230, 248, 236, 1.00)',
  'greenSolid100': 'rgba(178, 232, 195, 1.00)',
  'greenSolid200': 'rgba(141, 221, 165, 1.00)',
  'greenSolid300': 'rgba(90, 205, 124, 1.00)',
  'greenSolid400': 'rgba(57, 195, 99, 1.00)',
  'greenSolid500': 'rgba(8, 180, 60, 1.00)',
  'greenSolid600': 'rgba(7, 164, 55, 1.00)',
  'greenSolid700': 'rgba(6, 128, 43, 1.00)',
  'greenSolid800': 'rgba(4, 99, 33, 1.00)',
  'greenSolid900': 'rgba(3, 76, 25, 1.00)',
  'greenTransparent50': 'rgba(8, 180, 60, 0.05)',
  'greenTransparent100': 'rgba(8, 180, 60, 0.10)',
  'greenTransparent200': 'rgba(8, 180, 60, 0.20)',
  'greenTransparent300': 'rgba(8, 180, 60, 0.30)',
  'greenTransparent400': 'rgba(8, 180, 60, 0.40)',
  'greenTransparent500': 'rgba(8, 180, 60, 0.50)',
  'greenTransparent600': 'rgba(8, 180, 60, 0.60)',
  'greenTransparent700': 'rgba(8, 180, 60, 0.70)',
  'greenTransparent800': 'rgba(8, 180, 60, 0.80)',
  'greenTransparent900': 'rgba(8, 180, 60, 0.90)',
  'redSolid50': 'rgba(255, 240, 240, 1.00)',
  'redSolid100': 'rgba(240, 187, 187, 1.00)',
  'redSolid200': 'rgba(228, 129, 129, 1.00)',
  'redSolid300': 'rgba(224, 109, 109, 1.00)',
  'redSolid400': 'rgba(217, 81, 81, 1.00)',
  'redSolid500': 'rgba(208, 37, 37, 1.00)',
  'redSolid600': 'rgba(189, 34, 34, 1.00)',
  'redSolid700': 'rgba(148, 26, 26, 1.00)',
  'redSolid800': 'rgba(114, 20, 20, 1.00)',
  'redSolid900': 'rgba(73, 13, 13, 1.00)',
  'redTransparent50': 'rgba(208, 37, 37, 0.05)',
  'redTransparent100': 'rgba(208, 37, 37, 0.10)',
  'redTransparent200': 'rgba(208, 37, 37, 0.20)',
  'redTransparent300': 'rgba(208, 37, 37, 0.30)',
  'redTransparent400': 'rgba(208, 37, 37, 0.40)',
  'redTransparent500': 'rgba(208, 37, 37, 0.50)',
  'redTransparent600': 'rgba(208, 37, 37, 0.60)',
  'redTransparent700': 'rgba(208, 37, 37, 0.70)',
  'redTransparent800': 'rgba(208, 37, 37, 0.80)',
  'redTransparent900': 'rgba(208, 37, 37, 0.90)',
  'brandsSolidPlaystation': 'rgba(0, 101, 203, 1.00)',
  'brandsSolidXbox': 'rgba(17, 113, 17, 1.00)',
  'brandsSolidNintendo': 'rgba(226, 0, 19, 1.00)',
  'neutralSolid100': 'rgba(255, 255, 255, 1.00)',
  'neutralSolid150': 'rgba(255, 255, 255, 1.00)',
  // Use 'on' prefix for any color that is meant to be used on top of another color
  'onPrimarySolid50Heading': 'rgba(0, 0, 0, 1.00)',
  'onPrimarySolid50HeadingSubtle': 'rgba(0, 0, 0, 0.75)',
  'onPrimarySolid50Caption': 'rgba(0, 0, 0, 0.50)',
  'onPrimarySolid50CaptionSubtle': 'rgba(0, 0, 0, 0.25)',

  'onPrimarySolid200Heading': 'rgba(255, 255, 255, 1.00)',
  'onPrimarySolid200HeadingSubtle': 'rgba(255, 255, 255, 0.75)',
  'onPrimarySolid200Caption': 'rgba(255, 255, 255, 0.50)',
  'onPrimarySolid200CaptionSubtle': 'rgba(255, 255, 255, 0.25)',

  'onPrimarySolid300Heading': 'rgba(255, 255, 255, 1.00)',
  'onPrimarySolid300HeadingSubtle': 'rgba(255, 255, 255, 0.75)',
  'onPrimarySolid300Caption': 'rgba(255, 255, 255, 0.50)',
  'onPrimarySolid300CaptionSubtle': 'rgba(255, 255, 255, 0.25)',

  'onPrimarySolid500Heading': 'rgba(255, 255, 255, 1.00)',
  'onPrimarySolid500HeadingSubtle': 'rgba(255, 255, 255, 0.75)',
  'onPrimarySolid500Caption': 'rgba(255, 255, 255, 0.50)',
  'onPrimarySolid500CaptionSubtle': 'rgba(255, 255, 255, 0.25)',
}
